import { useCallback, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { Dialog, Toast } from "react-vant"
import finger from "@/assets/images/finger_up.png"
import refining_img from '@/assets/images/cards/refining.svg'
import "./index.less"
import { HighlightPercentages_1 } from "../../utils"
import ButtonComp from "../common/ButtonComp"
import { putGuideTypeList, getGuideTypeList } from "@/api/account.js"
import { useDispatch } from "react-redux"
import { changeGuideTypeList } from "../../store/module/progress"

const BattleHomeGuide = () => {
  const [visible, setVisible] = useState(true)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [keys, setKeys] = useState([
    'character_card',
    'nft_card',
    'diamond_card',
    'gold_card',
    'silver_card',
    'bronze_card',
  ])
  const navList = [
    {
      name: t("card.index.sale"),
      id: 1,
    },
    {
      name: t("card.index.display"),
      id: 2,
    },
    {
      name: t("card.index.mine"),
      id: 3,
    },
  ]

  const pkGuideText = [
    {
      text: t("pkGuideText.text_3"),
      id: 3,
    },
  ]

  const [add, setAdd] = useState(0)

  const getGuideType = async () => {
    const { code, data } = await getGuideTypeList()
    if (code == 0) {
      let obj: any = {}
      if (Array.isArray(data.tasks)) {
        data.tasks.forEach((el: any) => {
          obj[el.code] = el.status
        });
        dispatch(changeGuideTypeList({ ...data, tasks: obj }))
      }else {
        dispatch(changeGuideTypeList(data))
      }
    }
  }


  return (
    <Dialog
      visible={visible}
      showConfirmButton={false}
      showCancelButton={false}
      closeOnClickOverlay={false}
      onClose={() => { setVisible(false) }}
      width={'100%'}
    >
      <div className="h-[100vh] w-[100%]" onClick={async () => {
        if (add < 2) {
          setAdd(add + 1)
        } else {
          const toast = Toast.loading({
            message: t("other.loading"),
            forbidClick: true,
            duration: 0
          })
          await putGuideTypeList('pkHomeGuide')
          await getGuideType()
          toast.clear()
        }
      }}>
        {/* 第一步 */}
        <div className="w-[calc(100%_-_32px)] fixed bottom-[130px] ml-4 ">
          <div className=" triangle-down rounded-[10px] ml-[12px] mb-[50px] w-[250px] relative p-[10px] right-4 bg-white">
            <img className=" w-[31px] finger_down h-11 absolute left-[50%] rotate-180 -translate-x-[50%] -bottom-[50px] z-10" src={finger} alt="" />
            <p className="text-[16px] text-[#333] leading-[19px] font-semibold"
              dangerouslySetInnerHTML={{ __html: HighlightPercentages_1(pkGuideText[0].text) }}></p>
          </div>
          <div
            style={{ background: 'linear-gradient( 90deg, #00E49F 0%, #54ADFF 100%)', borderRadius: '10px' }}
            className="px-[5px] flex justify-between pt-[23px] pb-[10px] w-[calc(100%)] relative h-[93px]">
            <div className="px-[10px] py-1 absolute top-[-13px]" style={{ background: '#113A38', borderRadius: '10px 10px 0px 0px' }}>
              <p className="text-style-1 text-[14px] leading-[18px] font-bold">{t("pk.my_deck")}</p>
            </div>
            <div className=" flex gap-[5px]">
              <>
                {keys.map((el: string) =>
                  <div className=" w-10 h-[60px] bg-[rgb(255,255,255,0.5)] rounded-[10px] flex justify-center items-center" key={el}>
                    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                      <g id="优化页面" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="03-PK页主" transform="translate(-74.000000, -629.000000)" fill="#FFFFFF" fillRule="nonzero">
                          <g id="编组-4备份-2" transform="translate(16.000000, 575.000000)">
                            <g id="编组备份-3" transform="translate(58.000000, 54.000000)">
                              <path d="M22.8313043,13 L1.16869567,13 C0.525913044,13 0,12.55 0,12 C0,11.45 0.525913044,11 1.16869567,11 L22.8313043,11 C23.474087,11 24,11.45 24,12 C24,12.55 23.474087,13 22.8313043,13 Z" id="路径"></path>
                              <path d="M11,22.8313044 L11,1.16869564 C11,0.525913018 11.45,0 12,0 C12.55,0 13,0.525913045 13,1.16869564 L13,22.8313044 C13,23.474087 12.55,24 12,24 C11.45,24 11,23.474087 11,22.8313044 L11,22.8313044 Z" id="路径"></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                )}
              </>
              <div className=" justify-center flex items-center flex-col">
                <p className="mt-[3px] text-[19px] leading-[22px] text-[#fff] font-semibold">0</p>
                <p className="mt-[9px] text-[12px] leading-[19px] text-[#fff] font-semibold">{t("deck_configuration.total_power")}</p>
              </div>
            </div>
          </div>
        </div>
        <p onClick={async () => {
          const toast = Toast.loading({
            message: t("other.loading"),
            forbidClick: true,
            duration: 0
          })
          await putGuideTypeList('pkHomeGuide')
          await getGuideType()
          toast.clear()
        }} className=" absolute underline bottom-10 left-[50%] translate-x-[-50%] text-[14px] text-[#fff] leading-[18px] font-semibold">{t("skip_the_tutorial")}</p>
      </div>
    </Dialog>
  )
}
export default BattleHomeGuide
